import React from 'react';
import { useUser } from '../contexts/UserContext';

export default function Dashboard() {
  const { userData } = useUser();

  return (
    <div className="flex-1 overflow-y-auto p-6">
      <div className="max-w-7xl mx-auto">
        <div 
          className="bg-white rounded-xl border border-[var(--border-color)] p-6"
          style={{ boxShadow: 'var(--card-shadow)' }}
        >
          <h3 className="text-lg font-semibold text-[var(--accent-secondary)] mb-4">Dashboard</h3>
          <p className="text-[var(--text-secondary)]">
            Welcome to Toritech, {userData?.fullName || 'User'}!
          </p>
        </div>
      </div>
    </div>
  );
} 